export default {
    '.yr-loading': {
        width: '100px',
        height: '150px',
        position: 'relative',
        zIndex: 1,
        '&:before, &:after': {
            content: '""',
            backgroundImage:
                'url(https://res.cloudinary.com/kendra-scott/image/upload/v1744274318/UIImages/images/yellow-rose-gradient.svg)',
            display: 'block',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundSize: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top'
        },
        '&:after': {
            filter: 'brightness(0%)',
            animationDuration: '1.2s',
            animationTimingFunction: 'cubic-bezier(0.76, 0.05, 0.32, 1.47)',
            animationIterationCount: 'infinite',
            animationFillMode: 'both',
            animationName: 'waveFill',
            animationDirection: 'alternate'
        }
    },

    '@keyframes waveFill': {
        '0%': {
            height: '0%',
            animationTimingFunction: 'cubic-bezier(0.76, 0.05, 0.32, 1.47)'
        },
        '100%': {
            height: '100%',
            animationTimingFunction: 'ease-in-out'
        }
    },

    '.ks-spinner-wrapper .ks-spinner': {
        '.dot1 svg': {
            animationName: 'spinner-animation',
            animationDuration: '2000ms',
            animationIterationCount: 'infinite',
            margin: 'auto'
        }
    },

    '@keyframes spinner-animation': {
        '0%': {transform: 'rotate(0deg)'},
        '25%': {transform: 'rotate(0deg)'},
        '75%': {transform: 'rotate(360deg)'},
        '80%': {transform: 'rotate(300deg)'},
        '90%': {transform: 'rotate(370deg)'},
        '95%': {transform: 'rotate(350deg)'},
        '100%': {transform: 'rotate(360deg)'}
    },

    '@keyframes sk-rotate': {
        '100%': {transform: 'rotate(0deg)'}
    },

    '@keyframes sk-bounce': {
        '0%, 100%': {transform: 'scale(0)'},
        '50%': {transform: 'scale(1)'}
    }
}
